(() => {
  const priceSelector = '.collection-price-main';
  let frame = 0;

  function splitPriceParts(priceText) {
    const match = `${priceText || ''}`.trim().match(/^([^0-9]*)([0-9,]+)(?:\.([0-9]{2}))?$/);

    if (!match) return null;

    return {
      currency: match[1] || '$',
      dollars: match[2],
      cents: match[3] || '00'
    };
  }

  function formatPrice(price) {
    if (
      price.querySelector(':scope > .collection-price-currency') &&
      price.querySelector(':scope > .collection-price-dollars') &&
      price.querySelector(':scope > .collection-price-decimal') &&
      price.querySelector(':scope > .collection-price-cents')
    ) {
      return;
    }

    const parts = splitPriceParts(price.textContent);
    if (!parts) return;

    const currency = document.createElement('span');
    currency.className = 'collection-price-currency';
    currency.textContent = parts.currency;

    const dollars = document.createElement('span');
    dollars.className = 'collection-price-dollars';
    dollars.textContent = parts.dollars;

    const decimal = document.createElement('span');
    decimal.className = 'collection-price-decimal';
    decimal.textContent = '.';

    const cents = document.createElement('span');
    cents.className = 'collection-price-cents';
    cents.textContent = parts.cents;

    price.classList.add('collection-price-main-split');
    price.replaceChildren(currency, dollars, decimal, cents);
  }

  function syncProductPagePrices(root = document) {
    if (root.nodeType === Node.ELEMENT_NODE && root.matches(priceSelector)) {
      formatPrice(root);
    }

    root.querySelectorAll?.(priceSelector).forEach(formatPrice);
  }

  function scheduleSync() {
    if (frame) return;

    frame = requestAnimationFrame(() => {
      frame = 0;
      syncProductPagePrices();
    });
  }

  function initialize() {
    syncProductPagePrices();

    const root = document.getElementById('root');
    if (!root) return;

    new MutationObserver(scheduleSync).observe(root, {
      childList: true,
      subtree: true
    });
  }

  window.syncProductPagePrices = syncProductPagePrices;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
